import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import BookingCTA from "@/components/home/BookingCTA";
import LazyImage from "@/components/site/LazyImage";
import { FOOD } from "@/data/content";

export default function Food() {
  return (
    <PageShell testId="food-page">
      <PageHero
        overline="Taste · Malnad Kitchen"
        title={["Authentic", "Malnad Food"]}
        subtitle="Home-cooked forest-kitchen flavours, served warm and generous."
        image={FOOD.images[0]}
      />

      <section className="bg-ivory py-12 md:py-16">
        <div className="mx-auto max-w-4xl px-5 text-center md:px-10">
          <h2 className="font-display text-4xl font-bold leading-tight tracking-tight text-forest sm:text-5xl md:text-6xl">
            A taste of the hills, on every plate
          </h2>
          <p className="mt-7 text-lg text-charcoal/70">{FOOD.intro}</p>
        </div>

        {/* Photos */}
        <div className="mx-auto mt-14 grid max-w-[1400px] gap-5 px-5 md:grid-cols-2 md:px-10">
          {FOOD.images.map((img, i) => (
            <LazyImage key={i} src={img} alt={`Malnad food ${i + 1}`} fit="cover" className="aspect-video rounded-2xl" />
          ))}
        </div>

        {/* Menu */}
        <div className="mx-auto mt-14 max-w-[1200px] px-5 md:px-10">
          <p className="mb-3 text-center text-sm uppercase tracking-widest-2 text-brown md:text-base">Our In-House Menu</p>
          <h3 className="text-center font-display text-3xl font-bold text-forest md:text-5xl">What&apos;s Cooking</h3>

          <div className="mt-12 grid gap-6 md:grid-cols-2">
            {FOOD.menu.map((sec) => (
              <div key={sec.heading} className="rounded-2xl border border-charcoal/10 bg-card p-7 shadow-[0_10px_40px_rgba(26,54,38,0.05)] md:p-9">
                <h4 className="font-display text-2xl font-bold text-forest md:text-3xl">{sec.heading}</h4>
                <p className="mt-1 text-sm italic text-brown">{sec.note}</p>
                <ul className="mt-5 space-y-3">
                  {sec.items.map((it) => (
                    <li key={it} className="flex gap-3 text-charcoal/80">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <p className="mt-8 text-center text-sm text-charcoal/50">Menu is seasonal and can be customised — just let us know your preferences when you book.</p>
        </div>
      </section>

      <BookingCTA />
    </PageShell>
  );
}
